// ============================================================================
// sheep.batches.index — migrated off the global read
// ============================================================================
// The Sheep Batches hub owns its processing-batch list through one scoped,
// permanent resource. Saved views remain a nonblocking user-preference sidecar
// and do not replace or expand this route-data obligation.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'sheep.batches.index',
  obligations: Object.freeze([Object.freeze({id: 'sheep.batches.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
